export default {
  path: '/wecode/:type/guide',
  auth: true,
  preload: false,
  key: 'guide',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: () => import( /* webpackChunkName: "home" */'./index')
};
